




































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, classEdit, classDel } from '@/api/admin'
import { clientGroupList } from './client.api'
import Registration from './registration.vue'
import TitleBack from '@/components/titleBack/titleBack.vue'

@Component({
  components: {
    TitleBack,
    Registration
  }
})
export default class ClientList extends ViewBase {
  loading = true
  errMsg = ''
  total = 0
  page = 1
  pageSize = 10
  list = null
  title = ''
  dsubject = {}
  pagination: any = null
  columns: any = []
  lang = {}
  lang2: any = {}
  cVisible: boolean = false

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  showCode() {
    this.cVisible = true
  }

  onOk() {
    this.cVisible = false
  }

  setColumns() {
    const lang: any = this.lang2
    this.columns = [
      {
        title: '设备编号',
        dataIndex: 'number'
      },
      {
        title: '设备唯一码',
        dataIndex: 'client_group_name'
      },
      {
        title: '设备型号',
        dataIndex: 'count'
      },
    //   {
    //     title: '序列号',
    //     dataIndex: 'count'
    //   },
    //   {
    //     title: '可用容量',
    //     dataIndex: 'count'
    //   },
    //   {
    //     title: '剩余电量',
    //     dataIndex: 'count'
    //   },
    //   {
    //     title: '注册时间',
    //     dataIndex: 'count'
    //   }
    ]
  }
  created() {
    this.lang = this.i18n.vBinding
    this.lang2 = this.i18n.vClients
    this.fetch()
  }

  toClientGroup() {
    this.$router.push({
      name: 'clientGroup'
    })
  }
  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  async fetch(params: any = {}) {
    // console.log('params:', params)
    this.loading = true

    try {
      const { data } = await clientGroupList(params)

      const pagination: any = { ...this.pagination }
      // Read total count from server
      // pagination.total = data.totalCount;
      pagination.total = data.total
      this.loading = false
      this.list = data.list
      this.pagination = pagination
      this.setColumns()
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
